<div *ngIf="microsoft==false">
  <span class="subtitle">
    Google Email Server Configuration
  </span>

  <div class="list" style="padding-top: 30px;">
    <div class="list">
      <span>
        If you do wish to delete StayPrivate, return to the 'Settings for Gmail' page, scroll down to near the bottom and click on 'Compliance'. Then scroll down to 'Content compliance' and delete the rules 'Identify messages to send via StayPrivate' and 'Send secure replies to StayPrivate'.
        <br><br>
        Again, in the 'Settings for Gmail' page, scroll down to the bottom and click on 'Routing'. Scroll down to 'SMTP relay service' and delete the service 'Receive from StayPrivate'.
        <br><br>
        Finally, near the top of the 'Settings for Gmail' page, click on 'Hosts' and delete 'StayPrivate'.
        <br><br></span>
    </div>
  </div>
  <div class="link-box" style="margin-bottom: 20px;">
    <div class="link-svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#1A47D6">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
      </svg>
    </div>
    <span class="link-text">
      If you do not have administrator access to the mail server, please ask the email administrator to
      complete the configuration
      using the following link:
      <a target="_blank" href="https://stayprivate.com/server-configuration/#microsoft-delete">
        https://stayprivate.com/server-configuration/#google-delete</a>
    </span>
  </div>
</div>
<mat-card class="form-padding" *ngIf="microsoft==null">
  <mat-spinner diameter="70" style="margin: 50px auto 50px auto;"></mat-spinner>

</mat-card>

<mat-horizontal-stepper *ngIf="microsoft" [linear]="false" #setupStepper class="invis-stepper" (selectionChange)="onTabChanged($event);">
  <mat-step>
    <!--3 -->
    <!--3 -->
    <span class="paragraph">
      To remove the configuration from your company email server, select 'Automatic Removal'. Or if you prefer to do it
      yourself,
      select
      'Manual Removal' and follow the instructions on the next page.
    </span>

    <div style="margin: 40px 0px;">
      <button mat-flat-button color="primary" style="width: 220px;" (click)="setupCompany()"
        class="sp-background setup-button center" *ngIf="!autoDisabled">Automatic Removal</button>
      <div *ngIf="autoDisabled" [matTooltipDisabled]="false" matTooltip="Sorry! Our Automatic Configuration is temporarily unavailable. We hope to have it back online very soon. Please choose the Manual Configuration option, 
        and if you require any help, contact us at support@stayprivate.com.">

        <button mat-flat-button color="primary" style="width: 220px;" (click)="this.setupStepper.selectedIndex = 4"
          class="setup-button center" disabled>Automatic Removal</button>
      </div>
      <button mat-flat-button color="primary" style="width: 220px;" (click)="this.setupStepper.selectedIndex = 1"
        class="sp-background setup-button center">Manual Removal</button>
      <button mat-flat-button color="primary" style="width: 220px;" (click)="this.setupStepper.selectedIndex = 2"
        class="sp-background setup-button center">PowerShell Removal</button>
    </div>
    <div class="link-box" style="margin-bottom: 20px;">
      <div class="link-svg">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#1A47D6">
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
        </svg>
      </div>
      <span class="link-text">
        If you do not have administrator access to the corporate mail server, please ask the administrator to complete
        the
        configuration using
        the following link:
        <a target="_blank" href="https://stayprivate.com/server-configuration/#microsoft-delete">
          https://stayprivate.com/server-configuration/#microsoft-delete</a>
      </span>
    </div>
    <mat-step>
      <!-- 5 -->
      <!-- 5 -->
      <span class="subtitle">
        Microsoft Email Server Configuration
      </span>

      <div class="list" style="padding-top: 30px;">
        <div class="list">
          <span>
            If you wish to delete StayPrivate from your mail server, all you need to do is to navigate to the 'Exchange
            Admin Center' then under the 'Mail flow' section on the left, select 'Rules'. Select the circle next to the
            rule called 'Identify messages to send via StayPrivate' and then click on the 'Delete' button above.
            <br><br>
            This is enough to stop StayPrivate working. But it is recommended to also delete the other StayPrivate rules
            'StayPrivate Allow' and 'Send secure replies to StayPrivate'. You will find these in the same place.
            <br><br>
            Finally, select 'Connectors' under 'Mail flow' and delete the connectors 'Send to StayPrivate' and 'Receive
            from StayPrivate'.
            <br><br>
            <!-- Alternatively, you can log into Exchange Online Powershell and remove the rules and connectors using the commands below: -->
          </span>
          <!-- <ul style="padding-top: 20px;padding-bottom: 15px;">
                    <li><span class="sp-copy" (click)='copy(powershellRules.identifyRule)'>{{powershellRules.identifyRule}}</span></li>
                    <li><span class="sp-copy" (click)='copy(powershellRules.replyRule)'>{{powershellRules.replyRule}}</span></li>
                    <li><span class="sp-copy" (click)='copy(powershellRules.allowRule)'>{{powershellRules.allowRule}}</span></li>
                    <li><span class="sp-copy" (click)='copy(powershellRules.outboundConnector)'>{{powershellRules.outboundConnector}}</span></li>
                    <li><span class="sp-copy" (click)='copy(powershellRules.inboundConnector)'>{{powershellRules.inboundConnector}}</span></li>
                  </ul> -->
        </div>
      </div>
      <div class="link-box" style="margin-bottom: 20px;">
        <div class="link-svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#1A47D6">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path
              d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
          </svg>
        </div>
        <span class="link-text">
          If you do not have administrator access to the mail server, please ask the email administrator to
          complete the configuration
          using the following link:
          <a target="_blank" href="https://stayprivate.com/server-configuration/#microsoft-delete">
            https://stayprivate.com/server-configuration/#microsoft-delete</a>
        </span>
      </div>
      <div class="main-margin">
        <div class="div-margin" style="max-width: 750px;">
          <button mat-stroked-button class="sp-back-btn" type="button" (click)="this.setupStepper.selectedIndex = 0"
            style="float: left;">Back</button>
          <!-- <button mat-flat-button color="primary" class="sp-background" style="float: right;"
                  matStepperNext>Next</button> -->
        </div>
      </div>

    </mat-step>

  </mat-step>
  <mat-step *ngIf="!domain">
    <span class="paragraph">
      To use the Automated Configuration, enter your corporate email domain (such as company.com):
    </span>
    <div class="div-margin" style="padding-top:20px;">
      <mat-form-field appearance="outline" style="width: 100%;max-width: 300px; display: block;">
        <input matInput placeholder="stayprivate.com" class="text-padding" [(ngModel)]="inputDomain" type="text">
        <!-- <mat-error *ngIf="setupForm.controls['Domain'].hasError('required')">
          A domain is <strong>required</strong>.
        </mat-error>
        <mat-error *ngIf="setupForm.controls['Domain'].hasError('pattern')">
          The domain must be <strong>valid</strong>. @ symbol is not required.
        </mat-error> -->
      </mat-form-field>
    </div>
    <span class="paragraph">
      Please note that the domain needs to be provisioned with StayPrivate for the service to operate. You can check
      this by logging into the StayPrivate dashboard at <a target="_blank"
        [routerLink]="['/']">https://admin.stayprivate.com</a>.
    </span>
    <div class="div-margin" style="max-width: 750px; padding: 20px 10px">
      <button mat-flat-button color="primary" class="sp-background center" style="float: right;"
        (click)="this.setupStepper.next()">Next</button>
      <button mat-stroked-button class="sp-back-btn" type="button" (click)="this.setupStepper.selectedIndex = 0"
        style="float: left;">Back</button>
    </div><br>
  </mat-step>
  <!-- START OF SETUP VIA MSPOWERSHELL -->
  <mat-step>

    <span class="paragraph">
      Your exchange environment is easily configured for StayPrivate using the Exchange Online PowerShell
      Module.<br><br>
      You will need the following before continuing:
      <div class="list">
        <ul>
          <li>Have PowerShell installed. We recommend PowerShell 7.</li>
          <li>Have installed the ExchangeOnlineManagement module.</li>
          <li>Have administrator access to your Microsoft 365 account.</li>
        </ul>
        <span>Further details can be found here: <br><a target="_blank"
            href="https://learn.microsoft.com/en-us/powershell/exchange/connect-to-exchange-online-powershell?view=exchange-ps">https://learn.microsoft.com/en-us/powershell/exchange/connect-to-exchange-online-powershell?view=exchange-ps</a></span>
      </div>
    </span>


    <div class="div-margin" style="max-width: 750px;margin: 30px auto;">
      <button mat-stroked-button class="sp-back-btn" type="button"
        (click)="this.setupStepper.selectedIndex = 0">Back</button>
      <button mat-flat-button color="primary" matStepperNext class="sp-background " style="float: right;">Next</button>
    </div>
  </mat-step>


  <mat-step>
    <span class="paragraph">
      Copy and Paste the following commands into your PowerShell.
      <div class="list">
        <ul style="padding-top: 0px;padding-bottom: 15px;">
          <li class='powershell-li'><span class="sp-copy"
              (click)="copy(powershellRules.connect)">{{powershellRules.connect}}</span></li>
          <li class='powershell-li'>Copy the code given, use it to log in at: <a target="_blank"
              href="https://microsoft.com/devicelogin">https://microsoft.com/devicelogin</a>, and wait for your
            powershell session to be authenticated.</li>
          <li class='powershell-li'><span class="sp-copy"
              (click)='copy(powershellRules.outboundConnector)'>{{powershellRules.outboundConnector}}</span></li>
          <li class='powershell-li'><span class="sp-copy"
              (click)='copy(powershellRules.inboundConnector)'>{{powershellRules.inboundConnector}}</span></li>
          <li class='powershell-li'><span class="sp-copy"
              (click)='copy(powershellRules.identifyRule)'>{{powershellRules.identifyRule}}</span></li>
          <li class='powershell-li'><span class="sp-copy"
              (click)='copy(powershellRules.replyRule)'>{{powershellRules.replyRule}}</span></li>
          <li class='powershell-li'><span class="sp-copy"
              (click)='copy(powershellRules.allowRule)'>{{powershellRules.allowRule}}</span></li>

        </ul>
      </div>
    </span>
    <div class="div-margin" style="max-width: 750px;margin: 30px auto;">
      <button mat-stroked-button class="sp-back-btn" type="button"
        (click)="this.setupStepper.selectedIndex = 2">Back</button>
    </div>
  </mat-step>

  <mat-step>
    <!-- 5 -->
    <!-- 5 -->
    <span class="paragraph">
      We require you to grant us temporary access to your Microsoft mail server in order to configure your company's
      mail flow settings. <br> <br> Copy the
      code and
      then click 'Authenticate' to open a Microsoft authentication window. Then follow the instructions to grant access.
    </span>

    <mat-spinner *ngIf="loading" diameter="70" style="margin: 50px auto 50px auto;"></mat-spinner>
    <div *ngIf="!loading" class="main-margin">
      <div class="div-margin" *ngIf="dataSource[1].status != 'S'">
        <mat-label>Authentication Code</mat-label><br>
        <mat-form-field appearance="outline" style="width: 100%;max-width: 300px; display: block;">
          <input matInput placeholder="Generating code..." class="text-padding" [(ngModel)]="msAuthToken"
            [disabled]="true">
          <button matSuffix mat-icon-button aria-label="Copy Authentication Code" (click)="copy(msAuthToken)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="div-margin" *ngIf="dataSource[1].status != 'S'">
        <button mat-flat-button color="primary" class="sp-background center" style="float: right;"
          (click)="openAuth()">Authenticate</button>
        <button mat-stroked-button class="sp-back-btn" type="button" (click)="this.setupStepper.selectedIndex = 0"
          style="float: left;">Back</button>
      </div><br>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z2" style="width: 70%; margin: auto;"
        *ngIf="processing">
        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef> Stage </th>
          <td mat-cell *matCellDef="let step"> {{step.stage}} </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Status </th>
          <td mat-cell *matCellDef="let step" style="text-align: center;">
            <mat-spinner *ngIf="step.status==='P'" diameter="20" style="margin: auto;"></mat-spinner>
            <mat-icon *ngIf="step.status==='S'" style="color:#02b302; margin: auto;">done</mat-icon>
            <mat-icon *ngIf="step.status==='F'" style="color:#da1c1c; margin: auto;">close</mat-icon>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <span class="paragraph" *ngIf="dataSource[1].status != 'S'">
      Or if you would rather update the settings yourself, simply follow the instructions
      <a role="button" [routerLink]="" (click)="this.setupStepper.selectedIndex = 0">here</a>.
    </span> <br>
    <div class="link-box" style="margin-bottom: 20px;">
      <div class="link-svg">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#1A47D6">
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
        </svg>
      </div>
      <span class="link-text">
        If you do not have administrator access to the email server, please ask the email administrator to complete the
        configuration using
        the following link:
        <a target="_blank" href="https://stayprivate.com/server-configuration/#microsoft-delete">
          https://stayprivate.com/server-configuration/#microsoft-delete</a>
      </span>
    </div>
  </mat-step>
</mat-horizontal-stepper>